//react npm components
import React, { Component } from 'react'
import { connect } from 'react-redux';
import PropTypes from 'prop-types'
import axios from "axios";
//import "babel-polyfill";

//action 
import { resourceBundleAction } from "../middleware/resourceBundleAction";
import { fetchAction } from "../middleware/fetchAction"
import { getUrlMappingsAction } from '../middleware/getUrlMappingsAction';
import { getLoaderStatusAction } from '../middleware/getLoaderStatusAction';

//UI components
import Loader from '../components/Loader/Loader';
import MyComponent from '../components/MyComponent';
import Preview from './Preview';
import DataLayer from '../components/DataLayer';

//const MyComponent = lazy(() => import("../components/MyComponent"));
//const Preview = lazy(() => import("./Preview"));


export class MainLayout extends Component {
    constructor(props) {
        super(props);
        console.log('mainLayout props-----',props)
        this.state = {
            obj: this.props.fetch,
            isResourceBundleLoaded: this.props.resourceBundle ? true : false,
            methodInitiated: false,
            nonHeaderScreen: false,
            previousUrl: false,
            userLoggedIn: false,
            loading: false,
            scrollPositions : {},
            browseBack: false
        };
    }


    componentDidMount() {

        // this.props.getUrlMappingsAction("", `${this.props.preloadState.url}/get-url-mappings`);

        if (this.props.resourceBundle && this.props.resourceBundle.StorefrontUiLabels && !this.state.isResourceBundleLoaded) {
            this.setState({
                isResourceBundleLoaded: true,
                obj: this.props.fetch,
            })
            // Helper.setResourceBundle(this.props.resourceBundle)
            //this.render();
        }
    }

    componentWillUnmount() {
        console.log('mainLayout props componentWillUnmount')
        // In componentWillUnmount, remove the event listener to prevent memory leaks.
        window.removeEventListener('popstate', this.handlePopState);
        window.removeEventListener('popstate', this.handleBrowseBack);
      }

    handlePopState = () => {
        //In the handlePopState function, retrieve the stored scroll position and use window.scrollTo to restore it.
        const scrollPosition = this.state.scrollPositions[window.location.pathname];
        if (scrollPosition) {
          window.scrollTo(0, scrollPosition);
        }
      };

    componentDidUpdate(prevProps) {
        console.log('mainLayout props componentDidUpdate')
        if (prevProps.location.pathname !== this.props.location.pathname) {
         // In componentDidUpdate, store the scroll position for the previous route when the route changes.
          this.state.scrollPositions[prevProps.location.pathname] = window.scrollY;
        }
      }
    async componentWillReceiveProps(nextProps) {
        // console.log('nextProps.location ---- ', nextProps.location)
        // console.log('this.props.location ----- ', this.props.location)
        // if (nextProps.location !== this.props.location) {
        //     this.setState({ prevPath: this.props.location })
        //   }
        //   console.log('this.state ---- ', this.state)
        console.log('mainLayout props-----componentWillReceiveProps')
        window.onpopstate = this.handleBrowseBack;
        console.log('mainLayout props back', this.state.browseBack)
    
        if (nextProps.resourceBundle && nextProps.resourceBundle.StorefrontUiLabels && !this.state.isResourceBundleLoaded) {
            this.setState({
                isResourceBundleLoaded: true,
                obj: nextProps.fetch,
                methodInitiated: false
            })

            // Helper.setResourceBundle(nextProps.resourceBundle)
            //this.render();
        }
        //var postURL = actionUrl(window.location.pathname+window.location.search); 
        //var postURL= `${window.location.protocol}//${window.location.hostname}${window.location.pathname}${window.location.search}?format=json`;  
        var url = `${window.location.protocol}//${window.location.hostname}${window.location.pathname}${window.location.search}`;
        var format = (url.includes('?') ? `&format=json&ajax=true` : '?format=json&ajax=true');
        var postURL = `${url}${format}`
        var ajaxResponse;
        // localStorage.setItem('previousUrl',this.state.previousUrl);
        console.log('postURL and previousUrl ==== ', postURL, this.state.previousUrl)
        console.log('previousUrl from localStorage...',localStorage.getItem('previousUrl'));
         if (postURL == this.state.previousUrl || postURL == localStorage.getItem('previousUrl')) {
            console.log('inside if ')
            localStorage.setItem('previousUrl',postURL);
            window.location.reload()
         } else if (postURL && !this.state.methodInitiated) {
            setTimeout(this.props.getLoaderStatusAction(true), 1000)
            this.setState({
                methodInitiated: true,
                loading: false
            })

            var obj = await axios.get(postURL, {
                withCredentials: true
            }).then(function (response) {
                if (response.data && response.data.status != null && response.data.status == "302" && response.data.location) {
                    window.location.replace(response.data.location)
                } else {
                    ajaxResponse = response.data;
                }
            }).catch(function (err) {
                switch (err && err.response && err.response.status) {
                    case 302:
                        ajaxResponse = err.response.data;
                        var keywordredirectURL = err.response.headers && err.response.headers.ajaxredirect ? err.response.headers.ajaxredirect : ""
                        if (keywordredirectURL != "") {
                            window.location.replace(err.response.headers.ajaxredirect)
                        }
                        break;
                    case 404:
                        ajaxResponse = err.response.data;
                        break;
                    case 403:
                        if(err?.response?.data && err?.response?.data?.url){
                            window.location.reload();
                        }else{
                            ajaxResponse = err.response.data;
                        }
                        break;
                    case 500:
                        ajaxResponse = err.response.data;
                        break;
                    default:
                        break;
                }
            })

            this.setState({
                obj: ajaxResponse,
                previousUrl: postURL,
                methodInitiated: false,
                loading: false
            });
            localStorage.setItem('previousUrl',postURL);
            const titleElement = document.querySelector('title')
            if (ajaxResponse && ajaxResponse.pageTitle) {
                titleElement.innerHTML = ajaxResponse.pageTitle
            } else {
                titleElement.innerHTML = "Carolina Biological Supply"
            }
            const descriptionElement = document.querySelector("meta[name='description']");
            const keywordsElement = document.querySelector("meta[name='keywords']");

            if (ajaxResponse && ajaxResponse.hasOwnProperty('metaData') && ajaxResponse['metaData'].metaDescription) {
                descriptionElement.setAttribute('content', ajaxResponse['metaData'].metaDescription)
            }
            if (ajaxResponse && ajaxResponse.hasOwnProperty('metaData') && ajaxResponse['metaData'].metaKeywords) {
                keywordsElement.setAttribute('content', ajaxResponse['metaData'].metaKeywords)
            }
            //document.querySelector('title').innerHTML = 'Test ColumbiaPipe'
            this.props.getLoaderStatusAction(false)
            if(this.state.browseBack == true){
             this.handlePopState()
            } else {
            this.scrollTop()
            }
            this.setState({
                browseBack: false
            });
            /* this.setState({
                loading: false
             })*/

        }
    }

    handleBrowseBack = () => {
        console.log('handleBrowseBack---')
        this.setState({
            browseBack: true
        });
    }

    isNotEmptyObject(obj) {
        for (var prop in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, prop)) {
                return true;
            }
        }
        return false;
    }
    scrollTop() {
        window.scrollTo(0, 0);
    }

    render() {
        const state = this.state.obj;
        //const  headerObj = this.state.headerObj;
        //this following line is to restrict multiple rendering of existing component
        if (this.isNotEmptyObject(state) && this.state.isResourceBundleLoaded && !this.state.loading) {
            //if (this.isNotEmptyObject(state) && this.state.isResourceBundleLoaded) {
            return (this.loadComponent(state))
        } else {
            return (<>

                <Loader></Loader></>
            )
        }
    }

    loadComponent(state) {
        var PageType = state['@type'];

        return (
            <div>
                <Preview />
                <DataLayer state={state} />
                <MyComponent type={PageType} state={state} />
                <style>
                    {state['customCss']}
                </style>
            </div>
        )
    }
}


const mapStateToProp = state => ({
    resourceBundle: state.resourceBundle.response,
    fetch: state.fetch.response,
    getUrlMappings: state.getUrlMappings.response,
    getLoaderStatus: state.getLoaderStatus.response,

});

MainLayout.propTypes = {
    resourceBundleAction: PropTypes.func.isRequired,
    fetchAction: PropTypes.func.isRequired,
    getUrlMappingsAction: PropTypes.func.isRequired,
    getLoaderStatusAction: PropTypes.func.isRequired

};

export default connect(mapStateToProp, { fetchAction, resourceBundleAction, getUrlMappingsAction, getLoaderStatusAction })(MainLayout);
